<template>
  <div>
    <b-button variant="primary" @click="launchWhatsAppSignup"
      >Login com Facebook</b-button
    >
  </div>
</template>

<script>
export default {
  props: {
    block: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      popup: null
    };
  },

  methods: {
    launchWhatsAppSignup() {
      // Launch Facebook login
      window.FB.login(
        function (response) {
          if (response.authResponse) {
            console.log("authResponse", response.authResponse);
          } else {
            console.log(
              "Usuário cancelou o login ou não autorizou completamente."
            );
          }
        },
        {
          config_id: "7522076867879900", // configuration ID obtained in the previous step goes here
          response_type: "code", // must be set to 'code' for System User access token
          override_default_response_type: true,
          extras: {
            setup: {},
            sessionInfoVersion: 2 //  Receive Session Logging Info
          }
        }
      );
    }
  }
};
</script>
